import { render, staticRenderFns } from "./stap-1.vue?vue&type=template&id=300a57d6&"
import script from "./stap-1.vue?vue&type=script&lang=js&"
export * from "./stap-1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GeneralBreadcrumbs: require('/data/www/nvpa.org/nvpa/nuxt/components/general/Breadcrumbs.vue').default,InschrijvingPersoonsgegevens: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Persoonsgegevens.vue').default,InschrijvingContactgegevens: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/Contactgegevens.vue').default,InschrijvingNavigation: require('/data/www/nvpa.org/nvpa/nuxt/components/inschrijving/navigation.vue').default})
